export default function Input({ label, error, className = '', as = 'input', children, ...rest }) {
  const Tag = as;
  return (
    <div className={className}>
      {label && <label className="label">{label}</label>}
      {as === 'select' ? (
        <select className="input-base" {...rest}>{children}</select>
      ) : (
        <Tag className="input-base" {...rest} />
      )}
      {error && <p className="text-xs text-red-400 mt-1">{error}</p>}
    </div>
  );
}
